import { render, staticRenderFns } from "./DevicesAssociationTab.vue?vue&type=template&id=5c65690c"
import script from "./DevicesAssociationTab.vue?vue&type=script&lang=js"
export * from "./DevicesAssociationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports